import packageFile from '../../../package.json';

/**
 * Combine local and remote config
 * @returns config object
 */
export const getFullConfig = () => {
  const __REMOTE_CONFIG__ = window.__REMOTE_CONFIG__;
  return {
    VERSION: packageFile.version,
    ...__APP_CONFIG__,
    ...__REMOTE_CONFIG__,
  };
};

/**
 * Pass back the config variable value specified in varName
 * @param {string} varName
 * @returns string
 */
export const getConfigVariable = (varName) => {
  const config = getFullConfig();
  return typeof config[varName] === 'undefined' ? '' : config[varName];
};
